import cleanedFilename from '~/util/cleanedFilename';
import TEST_ID from '~/components/NavigationFrame/index.testid';

export default {
  NOT_FOUND_PAGE: `${cleanedFilename(__filename)}-not-found-page`,
  PAGE_CONTAINER: TEST_ID.PAGE_CONTAINER,
};
